module.exports = __webpack_public_path__ + "img/e_3_22_g.73e25921.png";